module.exports = __webpack_public_path__ + "media/icons/inne-alerty@3x-e22c1546.svg";